module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "section"
  }, [_vm._v("TABLE OF CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/tp",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/alsoby",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Also by Ellery Queen")])]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/ata",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/cop",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/fm1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epigraph")])]), _vm._v(" "), _c('p', {
    staticClass: "crt1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/p01"
    }
  }, [_c('strong', [_vm._v("PART ONE")])])]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/p01"
    }
  }, [_vm._v("Much Ado About Something")])]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c02"
    }
  }, [_vm._v("La Belle Dame Sans Souci")])]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Design for Leaving")])]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("And Sudden Death")])]), _vm._v(" "), _c('p', {
    staticClass: "crt1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/p02",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("PART TWO")])])]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/p02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gentleman or the Tiger?")])]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thrust and Parry")])]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Camel That Walked Like a Man")])]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Glory That Was Rhys")])]), _vm._v(" "), _c('p', {
    staticClass: "crt1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/p03",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("PART THREE")])])]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/p03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lady of the Press")])]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Star Reporter Is Born")])]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cards Under the Table")])]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Affairs of Anatole")])]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Winni the Pooh et Cetera")])]), _vm._v(" "), _c('p', {
    staticClass: "crt1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/p04",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("PART FOUR")])])]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/p04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Storm over Glücke")])]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Earthly Discourse")])]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Quest for the OP")])]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Alarums and Discursions")])]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rape of the Awning")])]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Blonde in the Woodpile")])]), _vm._v(" "), _c('p', {
    staticClass: "crt1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/p05",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("PART FIVE")])])]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/p05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Everything But the Truth")])]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Sport of King")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-340136e6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/toc.vue
// module id = 72
// module chunks = 0